import React from "react";
import { useUpsellWidgetContainer } from "../../../hooks/useUpsellWidgetContainerContext";

export const MobilePhoneInput = ({ register, errors, name = 'mobilePhone' }) => {
    const { baseProps } = useUpsellWidgetContainer();
    return <div className="form-group">
        <input className={`form-control international-mobile-input ${errors[name] && 'upsell-input-invalid'}`}
            type="text"
            defaultValue={baseProps?.user?.mobile || ""}
            placeholder="Mobile number"
            autoComplete="off"
            {...register(name, { required: "Mobile number is required" })}
        />
        {errors[name] && <div className="upsell-input-error">{errors[name].message}</div>}
    </div>;
};